import { ExportRequiredDataModel } from '../../content-distribution/_index';
import { FieldType } from '../../custom-data/models/field-type-definition.model';
import { DisplayFieldConfiguration } from './ui-module-overview-configuration.model';
import { UiModuleGroupsConfig } from './ui-module.model';

export class UiModuleDetailsConfiguration {
  static default(headerConfigNull = false): UiModuleDetailsConfiguration {
    return {
      id: 0,
      showTasks: true,
      showFiles: true,
      showMessages: true,
      showNotes: true,
      showChat: true,
      showInvoices: true,
      showPhotos: ShowPhotos.WithFiles,
      headerConfig: headerConfigNull
        ? null
        : {
            showExportButton: true,
            showAddButton: true,
            showDeleteButton: true,
            showDuplicateButton: true,
            showViewChangesButton: true,
            invoiceFlows: [],
            selectedFlow: null,
            invoicingLinkedObjects: [],
          },
      objectsConfig: [],
      tabsConfig: null,
      requiredData: null,
    };
  }
}

export interface UiModuleDetailsConfiguration {
  id: number;
  showTasks: boolean;
  showFiles: boolean;
  showMessages: boolean;
  showNotes: boolean;
  showChat: boolean;
  showInvoices: boolean;
  showPhotos: ShowPhotos;
  headerConfig: UiModuleDetailsHeaderConfigModel;
  objectsConfig: UiModuleDetailsLinkedObjectsConfigModel[];
  tabsConfig: TabConfigModel[];
  requiredData?: ExportRequiredDataModel[];
}

export interface UiModuleDetailsHeaderConfigModel {
  showExportButton: boolean;
  showAddButton: boolean;
  showDeleteButton: boolean;
  showDuplicateButton: boolean;
  showViewChangesButton: boolean;
  invoiceFlows: string[];
  selectedFlow?: string;
  debtorSelector?: string;
  invoicingLinkedObjects?: string[];
}

export interface UiModuleDetailsLinkedObjectsConfigModel {
  field: string;
  order: number;
  showExportButton: boolean;
  showAddButton: boolean;
  showLinkButton?: boolean;
  showDeleteButton?: boolean;
  showDuplicateButton?: boolean;
  showBatchUpdateButton?: boolean;
  clickAction?: LinkedObjectClickAction;
  clickActionParameter?: string;
  objectMappingKey?: string;
  sortField?: string;
  sortFieldOrder?: boolean;
  displayFields?: string[];
  externalConfigurationId?: number;
  displayFieldsConfiguration?: DisplayFieldConfiguration[];
  groupsConfig?: UiModuleGroupsConfig;
  loadFromApi?: boolean;
  pageSize?: number;
  enableMultiSort?: boolean;
  fieldAlias?: string;
  // UI only
  name?: string;
  fieldType?: FieldType;
  options?: MultiSelectOption[];
}

export interface TabConfigModel {
  order?: number;
  displayName: string;
  systemCode: string;
  detailsConfigurationId?: number;
  detailsConfiguration?: UiModuleDetailsConfiguration;
}

export interface TabItem {
  name: string;
  originalName?: string;
  systemCode: string;
}

export enum LinkedObjectClickAction {
  None,
  Open,
  EditModal,
  EditInline,
}

export enum ShowPhotos {
  WithFiles = 1,
  WithFilter = 2,
  InSeparateBox = 3,
}

export interface MultiSelectOption<
  TValue extends string | number | null = string | number
> {
  label: string;
  value: TValue;
  icon?: string;
  customItemTemplate?: unknown;
}
